/* eslint-disable react/no-danger */
import React, { Component } from 'react';
import { Button, RadioButton, RadioButtonGroup } from 'carbon-components-react';
import { Editor } from 'react-draft-wysiwyg';
import { ContentState, EditorState, convertToRaw } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import { getDmService } from '../../../services/Api';
import { StepCard } from '../../index';
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

class BriefingRequestProduct extends Component {
  constructor(props) {
    super(props);
    this.state = {
      advanced: false,
      idxBriefing: 0,
      listBriefings: [],
      idUrl: null,
      editorState: EditorState.createEmpty(),
      // eslint-disable-next-line react/no-unused-state
      createText: undefined,
    };
  }

  componentWillMount = () => {
    const { dataRequest } = this.props;
    const existDataRequest = Object.prototype.hasOwnProperty.call(dataRequest, 'idGrupo');

    if (existDataRequest) {
      this.loadProductRequest();
      this.implementValuesRequest();
    }
  };

  componentWillUpdate = async () => {
    const { match } = this.props;
    const { idUrl } = this.state;
    if (idUrl !== match.params.id) {
      await this.setState({
        idUrl: match.params.id
      });
    }
  };

  componentDidMount() {
  this.setState({ createText: null });
  
  };

  componentWillReceiveProps(newProps) {
    const { listBriefings } = this.state;
    const { dataProduct, dataRequest } = newProps;
    const existDataRequest = Object.prototype.hasOwnProperty.call(dataRequest, 'idGrupo');
    const { listSizes } = dataProduct;

    const newList = [];
    if (!existDataRequest) {
      if (listSizes) {
        listSizes.forEach(item => {
          newList.push({
            id: item.indice,
            value: item.value,
            otherValues: item,
            texto: item.texto || ''
          });
        });
      }
      this.setState({
        listBriefings: newList
      });
    } else {
      const list = dataRequest.detalhes.map(item => ({
        id: item.id,
        texto: item.briefing
      }));
      listSizes.forEach((item, idx) => {
        if (listBriefings.length > idx) newList.push(listBriefings[idx]);
        else if (list.length > idx) newList.push(list[idx]);
        else {
          newList.push({ id: 0, texto: '' });
        }
      });
      this.setState({ listBriefings: newList });
    }
  }

  loadProductRequest = async () => {
    const { dataRequest } = this.props;
    const { idProduto } = dataRequest;
    try {
      const data = await getDmService(`/Pedido/GetNomeProduto/?grupo=${dataRequest.idGrupo}`);
      const idsSearch = data.find(item => parseInt(item.id, 10) === parseInt(idProduto, 10));
      const productRequest = { id: idsSearch.id, label: idsSearch.nome };
      this.setState({
        productRequest
      });
    } catch (error) {
      console.log(error);
    }
  };

  implementValuesRequest = () => {
    const { dataRequest } = this.props;
    const existDataRequest = Object.prototype.hasOwnProperty.call(dataRequest, 'idGrupo');

    if (existDataRequest) {
      const list = dataRequest.detalhes.map(item => ({
        id: item.id,
        texto: item.briefing
      }));

      let editorState = EditorState.createEmpty();

      if (list[0].texto) {
        const blocksFromHtml = htmlToDraft(list[0].texto);
        const { contentBlocks, entityMap } = blocksFromHtml;
        const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
        editorState = EditorState.createWithContent(contentState);
      }

      this.setState({
        listBriefings: list,
        editorState
      });
    }
  };

  renderCreateText = () => {
  const { createText } = this.state;
  const { onCreateTextChange } = this.props;
  return (
    <React.Fragment>
      <div className='radio-input'>
        <p className='color-red'><b>Este pedido envolve a criação ou revisão de texto?</b></p>
        <div className="inline-radio">
          <RadioButtonGroup
            legendText="Radio button heading"
            name="CriarTexto"
            valueSelected={createText !== undefined && createText !== null ? String(createText) : undefined}
            onChange={value => {
              this.setState({ createText: value }); // Salva como string
              if (onCreateTextChange) {
                onCreateTextChange(value); // Passa string para o pai
              }
            }}
          >
            <RadioButton
              value="1"
              labelText="Sim"
              id="radio-1"
            />
            <RadioButton
              value="0"
              labelText="Não"
              id="radio-2"
            />
          </RadioButtonGroup>
        </div>
      </div>
    </React.Fragment>
  );
};

  renderDescription = () => {
  const { dataProduct, dataRequest, isKit } = this.props;
  const { productSave } = dataProduct;
  const { listBriefings, productRequest } = this.state;
  const nameProduct =
    productSave && productSave.label
      ? productSave.label
      : productRequest
        ? productRequest.label
        : '';

  return (
    <React.Fragment>
      {dataRequest.criarTexto === 1 && (
        <p className="description">
          <strong>Este pedido envolve a criação ou revisão de texto</strong>
        </p>
      )}
      <p className="description">
        Descreva o que você precisa, com informações relevantes para a criação da arte/texto: objetivo, público-alvo, abordagem desejada, aplicações ( Digital ou física), Pontos a serem destacados, desdobramentos etc.
      </p>
      {listBriefings.length > 0 && !isKit &&
        listBriefings.map((item, index) => (
          <p key={index} className="description">
            <strong>{`${nameProduct} ${index + 1} ${item.texto ? ' - ' : ''}`}</strong>
            <div dangerouslySetInnerHTML={{ __html: item.texto }} />
          </p>
        ))}
      {listBriefings.length > 0 && isKit && (
        <p key={0} className="description">
          <strong>{`${nameProduct} ${listBriefings[0].texto ? ' - ' : ''}`}</strong>
          <div dangerouslySetInnerHTML={{ __html: listBriefings[0].texto }} />
        </p>
      )}
    </React.Fragment>
  );
};

  advance = async () => {
    const { saveStep } = this.props;
    const { listBriefings } = this.state;
    await saveStep(
      {
        listSizes: listBriefings
      },
      'briefing'
    );
    await this.stepCardRef.toggleContent();
  };

  cancel = () => {
    this.stepCardRef.toggleContent();
  };

  briefingOk = () => {
    const { dataProduct } = this.props;
    const { listBriefings, editorState } = this.state;
    const { dataFilters } = dataProduct || {};

    const validacao = listBriefings.filter(p => !p.texto).length === 0;
    if (dataFilters && !dataFilters.briefing)
      return true;

    if (editorState)
      return true;

    return validacao;
  }

  onChangeText = event => {
    const { target } = event;
    const { value } = target;
    const { idxBriefing, listBriefings } = this.state;
    const { isKit } = this.props;
    if (isKit) {
      listBriefings.forEach(item => {
        // eslint-disable-next-line no-param-reassign
        item.texto = value;
      });
    } else {
      listBriefings[idxBriefing].texto = value;
    }

    this.setState({
      listBriefings
    });
  };


  addTag = async (tag, idx) => {
    const { listBriefings } = this.state;

    await this.setState({
      idxBriefing: idx
    });

    let txtTag = '';
    if (tag === '<CHAMADA>') {
      txtTag = ' <p>Chamada</p> ';
    } else if (tag === '<PRAZO>') {
      txtTag = ' <p>Tenha + prazo pra pagar</p> ';
    } else if (tag === '<DESCONTOS_OFERTAS>') {
      txtTag = ' <p>Descontos e ofertas exclusivas</p> ';
    } else if (tag === '<BAIXE_APP>') {
      txtTag = ' <p>whatsapp + qrcode</p> ';
    } else if (tag === '<AUMENTO_LIMITE>') {
      txtTag = ' <p>Aumento de limite</p> ';
    } else if (tag === '<RAPIDA_APROVACAO>') {
      txtTag = ' <p>Rápida aprovação</p> ';
    } else if (tag === '<CARTAO_ADICIONAL>') {
      txtTag = ' <p>Cartão adicional</p> ';
    } else {
      txtTag = ' <p>Parcelamento em X</p> ';
    }

    listBriefings[idx].texto += await txtTag;

    const blocksFromHtml = htmlToDraft(listBriefings[idx].texto);
    const { contentBlocks, entityMap } = blocksFromHtml;
    const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
    const editorState = EditorState.createWithContent(contentState);

    await this.setState({
      listBriefings,
      editorState
    });
  };

  renderOptional = () => {
    const { dataProduct } = this.props;
    const { dataFilters } = dataProduct;

    if (dataFilters && !dataFilters.briefing) {
      return <span className="optional"> (opcional)</span>;
    }

    return '';
  };

  entityMapper = (entity) => {
    if (!entity) {
      return "";
    }
    if (entity.type === "DIV") {
      return `<div>${entity.data.innerHTML}</div>`;
    }
    if (entity.type === "TABLE") {
      return `<table>${entity.data.innerHTML}</table>`;
    }
    if (entity.type === "TBODY") {
      return `<tbody>${entity.data.innerHTML}</tbody>`;
    }
    if (entity.type === "TR") {
      return `<tr>${entity.data.innerHTML}</tr>`;
    }
    if (entity.type === "TH") {
      return `<th>${entity.data.innerHTML}</th>`;
    }
    if (entity.type === "TD") {
      return `<td>${entity.data.innerHTML}</td>`;
    }
    if (entity.type === "P") {
      return `<p>${entity.data.innerHTML}</p>`;
    }
    if (entity.type === "STYLE") {
      return `<style>${entity.data.innerHTML}</style>`;
    }
    return "";
  }

  onEditorStateChange = editorState => {
    const { listBriefings } = this.state;

    const editorHTML = draftToHtml(
      convertToRaw(editorState.getCurrentContent()),
      null,
      false,
      this.entityMapper()
    );

    listBriefings.forEach(item => {
      // eslint-disable-next-line no-param-reassign
      item.texto = editorHTML
    });
    // listBriefings[idxBriefing].texto = editorHTML;

    this.setState({
      editorState,
      listBriefings
    });
  };

  render() {
    const { advanced, listBriefings, productRequest, editorState,  } = this.state;
    const { disabledCard, isFinished, dataProduct, isKit, criarTexto } = this.props;
    const { productSave } = dataProduct;
    const { createText } = this.state;

    const nameProduct =
      productSave && productSave.label
        ? productSave.label
        : productRequest
          ? productRequest.label
          : '';
  
        // Verificação condicional para mostrar renderCreateText
        const shouldRenderCreateText = productSave && productSave.tipoUso && productSave.tipoUso.includes("Digital");

    return (
      <StepCard
        onRef={ref => {
          this.stepCardRef = ref;
        }}
        title="Briefing"
        optional={this.renderOptional()}
        description={this.renderDescription()}
        isFinished={isFinished}
        onToogle={advanced}
      >
        <div>
          <div>
            {shouldRenderCreateText && this.renderCreateText()}
          </div>
          {isKit ? (
            <div key={0}>
              <div className="bx--row">
                <div className="bx--col-xs-12 bx--col-md-12">
                  <label className="bx--label">{`${nameProduct}`}</label>
                  <Editor
                    editorState={editorState}
                    // toolbarClassName="toolbarClassName"
                    // wrapperClassName="wrapperClassName"
                    editorClassName="border-editor"
                    // onClick={() => this.setState({ idxBriefing: 0 })}
                    onEditorStateChange={this.onEditorStateChange}
                  />
                  {/* <TextArea
                    labelText=""
                    value={listBriefings.length > 0 ? listBriefings[0].texto : ""}
                    // onClick={() => this.setState({ idxBriefing: index })}
                    onChange={e => this.onChangeText(e)}
                    placeholder="Exemplo: Gostaria de um fundo azul, com uma pessoa segurando um cartão."
                    disabled={disabledCard}
                  /> */}
                </div>
              </div>
              {!disabledCard && (
                <div className="bx--row flexible sm-margin">
                  <div className="tags bx--col-xs-12 v-md-margin">
                    <button
                      className="button button--clear"
                      onClick={() => this.addTag('<Chamada>', 0)}
                      type="submit"
                    >
                      <span className="bx--tag bx--tag--ibm">Chamada</span>
                    </button>
                    <button
                      className="button button--clear"
                      onClick={() => this.addTag('<PRAZO>', 0)}
                      type="submit"
                    >
                      <span className="bx--tag bx--tag--ibm">+ prazo pra pagar</span>
                    </button>
                    <button
                      className="button button--clear"
                      onClick={() => this.addTag('<DESCONTOS_OFERTAS>', 0)}
                      type="submit"
                    >
                      <span className="bx--tag bx--tag--ibm">Descontos e ofertas exclusivas</span>
                    </button>
                    <button
                      className="button button--clear"
                      onClick={() => this.addTag('<BAIXE_APP>', 0)}
                      type="submit"
                    >
                      <span className="bx--tag bx--tag--ibm">whatsapp + qrcode</span>
                    </button>

                    <button
                      className="button button--clear"
                      onClick={() => this.addTag('<PARCELAMENTO>', 0)}
                      type="submit"
                    >
                      <span className="bx--tag bx--tag--ibm">Parcelamento</span>
                    </button>

                    <button
                      className="button button--clear"
                      onClick={() => this.addTag('<AUMENTO_LIMITE>', 0)}
                      type="submit"
                    >
                      <span className="bx--tag bx--tag--ibm">Aumento de limite</span>
                    </button>
                    <button
                      className="button button--clear"
                      onClick={() => this.addTag('<CARTAO_ADICIONAL>', 0)}
                      type="submit"
                    >
                      <span className="bx--tag bx--tag--ibm">Cartão adicional</span>
                    </button>
                    <button
                      className="button button--clear"
                      onClick={() => this.addTag('<RAPIDA_APROVACAO>', 0)}
                      type="submit"
                    >
                      <span className="bx--tag bx--tag--ibm">Rápida aprovação</span>
                    </button>
                    
                  </div>
                </div>
              )}
            </div>
          ) : (
            listBriefings.map((item, index) => (
              <div key={index}>
                <div className="bx--row">
                  <div className="bx--col-xs-12 bx--col-md-12">
                    <label className="bx--label">{`${nameProduct} ${index + 1}`}</label>
                    <Editor
                      editorState={editorState}
                      // toolbarClassName="toolbarClassName"
                      // wrapperClassName="wrapperClassName"
                      editorClassName="border-editor"
                      // onClick={() => this.setState({ idxBriefing: index })}
                      onEditorStateChange={this.onEditorStateChange}
                    />
                    {/* <TextArea
                      labelText=""
                      value={item.texto}
                      onClick={() => this.setState({ idxBriefing: index })}
                      onChange={e => this.onChangeText(e)}
                      placeholder="Exemplo: Gostaria de um fundo azul, com uma pessoa segurando um cartão."
                      disabled={disabledCard}
                    /> */}
                  </div>
                </div>
                {!disabledCard && (
                  <div className="bx--row flexible sm-margin">
                    <div className="tags bx--col-xs-12 v-md-margin">
                      <button
                        className="button button--clear"
                        onClick={() => this.addTag('<CHAMADA>', index)}
                        type="submit"
                      >
                        <span className="bx--tag bx--tag--ibm">Chamada</span>
                      </button>
                      <button
                        className="button button--clear"
                        onClick={() => this.addTag('<PRAZO>', index)}
                        type="submit"
                      >
                        <span className="bx--tag bx--tag--ibm">+ prazo pra pagar</span>
                      </button>
                      <button
                        className="button button--clear"
                        onClick={() => this.addTag('<DESCONTOS_OFERTAS>', index)}
                        type="submit"
                      >
                        <span className="bx--tag bx--tag--ibm">Descontos e ofertas exclusivas</span>
                      </button>
                      <button
                        className="button button--clear"
                        onClick={() => this.addTag('<BAIXE_APP>', index)}
                        type="submit"
                      >
                        <span className="bx--tag bx--tag--ibm">whatsapp + qrcode</span>
                      </button>
                     
                      <button
                        className="button button--clear"
                        onClick={() => this.addTag('<PARCELAMENTO>', index)}
                        type="submit"
                      >
                        <span className="bx--tag bx--tag--ibm">Parcelamento</span>
                      </button>

                      <button
                        className="button button--clear"
                        onClick={() => this.addTag('<AUMENTO_LIMITE>', index)}
                        type="submit"
                      >
                        <span className="bx--tag bx--tag--ibm">Aumento de limite</span>
                      </button>
                      <button
                        className="button button--clear"
                        onClick={() => this.addTag('<CARTAO_ADICIONAL>', index)}
                        type="submit"
                      >
                        <span className="bx--tag bx--tag--ibm">Cartão adicional</span>
                      </button>
                      <button
                        className="button button--clear"
                        onClick={() => this.addTag('<RAPIDA_APROVACAO>', 0)}
                        type="submit"
                      >
                        <span className="bx--tag bx--tag--ibm">Rápida aprovação</span>
                      </button>
                    </div>
                  </div>
                )}
              </div>
            ))
          )}

          {!disabledCard && (
            <div className="bx--row">
              <div className="bx--col-xs-12 bx--col-md-12 v-md-margin">
                <Button
                  disabled={
                      !this.briefingOk() ||
                      (shouldRenderCreateText && (createText === null || createText === undefined))
                    }
                  className="bx--btn btn-secondary-color"
                  onClick={this.advance}
                >
                    Avançar
                </Button>
                <Button
                  kind="ghost"
                  className="bx--btn btn-secondary-outlined h-sm-margin"
                  onClick={this.cancel}
                >
                  Cancelar
                </Button>
              </div>
            </div>
          )}
        </div>
      </StepCard>
    );
  }
}

export default BriefingRequestProduct;



// WEBPACK FOOTER //
// ./src/components/agency/requests/BriefingRequestProduct.js